"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/esnext.json.parse.js");
var _log = require("@/utils/log");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _SurveyImageInput = _interopRequireDefault(require("@/views/survey-builder/components/SurveyImageInput"));
var _index = require("./index");
var _cookie = require("@/utils/cookie");
var _survey = require("@/api/survey");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { SurveyDebug } from './index'
var _default = exports.default = {
  name: 'SurveyMain',
  components: {
    Tinymce: _Tinymce.default,
    SurveyPage: _index.SurveyPage,
    SurveyImageInput: _SurveyImageInput.default
    // SurveyDebug
  },
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data() {
    const defaultSurveyForm = {
      id: '',
      type: '',
      category: '',
      subcategory: '',
      title: '',
      description: '',
      accessMethod: '',
      accessKey: '',
      iconImg: '',
      iconDisableImg: '',
      backgroundColor: '',
      timesTake: 0,
      pages: [],
      equations: [],
      belongToHike: null,
      mailList: [],
      needNotifyEmail: true,
      emailTemplate: {
        subject: '',
        mailBody: ''
      },
      publish: ''
      // createdAt
      // updatedAt
    };
    return {
      fullscreenloading: false,
      isInUse: 'N',
      defaultSurveyForm,
      surveyForm: this.displayType === 'create' ? JSON.parse(JSON.stringify(defaultSurveyForm)) : null,
      surveyFormRules: {
        type: [{
          required: true,
          message: 'Please select survey type',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: 'Please enter survey title',
          trigger: 'blur'
        }],
        accessMethod: [{
          required: true,
          message: 'Please select access method',
          trigger: 'blur'
        }]
      },
      typeOptions: [{
        value: 'learning-passport',
        label: 'learning-passport'
      }, {
        value: 'manager720',
        label: 'manager720'
        // }, {
        //   value: 'hike',
        //   label: 'hike'
        // }, {
        //   value: 'loop',
        //   label: 'loop'
        // }, {
        //   value: 'vilt',
        //   label: 'vilt'
        // }, {
        //   value: 'other',
        //   label: 'other'
      }, {
        value: 'hike-feedback',
        label: 'hike-feedback'
      }],
      accessMethodOptions: [{
        value: 'user',
        label: 'user'
      }, {
        value: 'key',
        label: 'key'
      }, {
        value: 'public',
        label: 'public'
      }]
    };
  },
  created() {
    if (this.displayType === 'edit') {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const id = this.$route.params.id;
      this.fullscreenloading = true;
      (0, _survey.getSurveyIsInUse)(token, id).then(response => {
        this.fullscreenloading = false;
        this.isInUse = response.data.isInUse;
        this.getSurvey(id, false);
      }).catch(error => {
        (0, _log.showDebugLog)('survey-getSurveyIsInUse-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    } else if (this.displayType === 'createfromcopy') {
      const fromId = typeof this.$route.query.fromId === 'undefined' ? '' : this.$route.query.fromId;
      this.getSurvey(fromId, true);
    }
  },
  methods: {
    getSurvey(id, isCopy) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.fullscreenloading = true;
      (0, _survey.getSurveyById)(token, id).then(response => {
        const d = response.data;
        // check error and return immediate
        if (typeof d.id === 'undefined') {
          // this.fullscreenloading = false
          const msg = 'Cannot get the survey, please contact to system administrator';
          (0, _log.displayPopupMessage)(msg, 'error');
          return;
        }
        (0, _log.showDebugLog)('Survey-getSurveyById-response', d);
        // this.surveyForm.id = isCopy ? 'copy' : d.id

        this.fullscreenloading = false;
        if (isCopy) {
          const surveyForm = JSON.parse(JSON.stringify(this.defaultSurveyForm));

          // type
          surveyForm.type = this.$route.query.type === 'true' ? d.type : '';
          // category
          surveyForm.category = this.$route.query.c === 'true' ? d.category : '';
          // title
          surveyForm.title = this.$route.query.t === 'true' ? d.title : '';
          // description
          surveyForm.description = this.$route.query.d === 'true' ? d.description : '';
          // accessMethod
          surveyForm.accessMethod = this.$route.query.am === 'true' ? d.accessMethod : '';
          // accessKey
          surveyForm.accessKey = this.$route.query.ak === 'true' ? d.accessKey : '';
          // iconImg
          surveyForm.iconImg = this.$route.query.ii === 'true' ? d.iconImg : '';
          // iconDisableImg
          surveyForm.iconDisableImg = this.$route.query.idi === 'true' ? d.iconDisableImg : '';
          // backgroundColor
          surveyForm.backgroundColor = this.$route.query.bc === 'true' ? d.backgroundColor : '';
          // timesTake
          surveyForm.timesTake = this.$route.query.tt === 'true' ? d.timesTake : '';
          // pages
          surveyForm.pages = this.$route.query.p === 'true' ? d.pages : '';
          this.surveyForm = surveyForm;
        } else {
          // If survey is in use, disable all delete buttons
          if (this.isInUse === 'Y') {
            response.data.pages.forEach(page => {
              page.isDeletable = false;
              page.questions.forEach(question => {
                question.isDeletable = false;
              });
            });
          }
          this.surveyForm = Object.assign({}, this.defaultSurveyForm, response.data);
        }
      }).catch(error => {
        (0, _log.showDebugLog)('survey-getSurveyById-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    isValid() {
      if (this.surveyForm.type === '') {
        const msg = 'Type is missing';
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      if (this.surveyForm.title.trim() === '') {
        const msg = 'Title is missing';
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      if (this.surveyForm.accessMethod === '') {
        const msg = 'Access Method is missing';
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      return true;
    },
    doCreate(publishStatus) {
      if (!this.isValid()) {
        return;
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const formData = JSON.parse(JSON.stringify(this.surveyForm));
      formData.publish = publishStatus;

      // Remove useless page properties
      formData.pages.forEach(page => {
        delete page.label;
        delete page.isDeletable;
        delete page.thumbnailFile;
        delete page.showThumbnailUploadErrMsg;

        // Remove useless question properties
        page.questions.forEach(question => {
          delete question.isDeletable;
        });
      });
      this.fullscreenloading = true;
      (0, _survey.createSurvey)(token, formData).then(response => {
        (0, _log.showDebugLog)('training-create-response', response);
        this.fullscreenloading = false;
        const msg = `${response.data.title} (${response.data.id}) is created.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        if (this.displayType === 'createfromcopy' || this.displayType === 'create') {
          this.$router.push(`/survey/edit/${response.data.id}`);
        }
        (0, _ga.writeGaEvent)(this, 'Survey', `${_lifehikesInitData.userEvent.survey.create}`, oEmail, `Survey Id: ${response.data.id}`);
      }).catch(error => {
        (0, _log.showDebugLog)('survey-create-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    checkAndSave(publishStatus) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const id = this.$route.params.id;
      this.fullscreenloading = true;
      (0, _survey.getSurveyIsInUse)(token, id).then(response => {
        this.fullscreenloading = false;
        if (this.isInUse === 'N' && response.data.isInUse === 'Y') {
          this.$confirm('This survey is in use. Please refresh the page to get latest status.', 'Confirm', {
            confirmButtonText: 'OK and refresh',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            location.reload();
          }).catch(() => {});
        } else {
          this.doSave(publishStatus);
        }
      }).catch(error => {
        (0, _log.showDebugLog)('survey-getSurveyIsInUse-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    doSave(publishStatus) {
      if (!this.isValid()) {
        return;
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const id = this.$route.params.id;
      const formData = JSON.parse(JSON.stringify(this.surveyForm));
      formData.publish = publishStatus;

      // Remove useless page properties
      formData.pages.forEach(page => {
        delete page.label;
        delete page.isDeletable;
        delete page.thumbnailFile;
        delete page.showThumbnailUploadErrMsg;

        // Remove useless question properties
        page.questions.forEach(question => {
          delete question.isDeletable;
        });
      });
      this.fullscreenloading = true;
      (0, _log.showDebugLog)('Save Form', formData);
      (0, _survey.updateSurveyById)(token, id, formData).then(response => {
        (0, _log.showDebugLog)('Survey-update-response', response);
        this.fullscreenloading = false;
        // this.surveyForm.id = response.data.id
        this.surveyForm.publish = response.data.publish;
        const msg = `${response.data.title} (${response.data.id}) is updated.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(this, 'Survey', `${_lifehikesInitData.userEvent.survey.edit}`, oEmail, `Survey Id: ${response.data.id}`);
      }).catch(error => {
        (0, _log.showDebugLog)('Survey-update-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};